module.exports = __webpack_public_path__ + "static/room4-4c8a165d76fb0b11b07e1c6d6c6246de.jpg";